import { Box, Text, Inline, IconClose } from '@machobear/design-system'

const CustomTag = ({ name, onClear }: { name: string; onClear: () => void }) => {
  return (
    <Box
      borderRadius="full"
      boxShadow="borderNeutralLight"
      paddingX="xxsmall"
      paddingY="xxxsmall"
      background="navItem"
    >
      <Inline space="xxxsmall" alignY="center">
        <Text size="small">{name}</Text>
        <Box
          onClick={onClear}
          component="button"
          display="flex"
          alignItems="center"
          justifyContent="center"
          cursor="pointer"
          style={{ width: 16 }}
          role="button"
          name="remove-coupon"
        >
          <IconClose size="small" />
        </Box>
      </Inline>
    </Box>
  )
}

export default CustomTag
